import React, { useEffect, useState } from 'react';
import { Button, Descriptions, Icon, message, Modal, Select, Tabs } from "antd";

import Qrcode from "./qrcode";
import QrScan from "../../components/QrReader/QRScan";
import DocumentList from "../../components/AssetStockDocumentList";
import { resetLinkProcess } from "../../appRedux/actions";
import { connect } from "react-redux";

const { TabPane } = Tabs;
const ButtonGroup = Button.Group;


const mapStateToProps = (state) => {
  return {
    // will be available as props.trips
    lStatus: state.linkStatus
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    // will be available as props.fetch()
    reset: () => dispatch(resetLinkProcess())
  }
}

function Linker(props) {

  const {
    coords,
    asset,
    linkType = 'QR',
    toggleView,
    isVisible,
    qrUsed,
    checkQrAlreadyUsed,
    match,
    history,
    form,
    createLink,
    loading: globalLoading,
    linkStatus,
    allTagTypes,
    getAllTagTypes,
  } = props;

  const [activeTab, setActiveTab] = useState('1');
  const [qrId, setQrId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [newQrId, setNewQrId] = useState(null);
  const [isOpenCamera, setIsOpenCamera] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [lastTagType, setLastTagType] = useState(null);

  const [documentData, setDocumentData] = useState([]);
  const [tagType, setTagType] = useState(null);

  // const resetLinkStatus = () =>{
  //     const dispatch = useDispatch();
  //     useEffect(() => {
  //         dispatch(resetLinkProcess());
  //     }, []);
  // }

  useEffect(() => {
    getAllTagTypes();
    const tagType = localStorage.getItem("last_tag_type");
    // console.log(tagType)
    if (tagType) {
      setLastTagType(JSON.parse(tagType));
      setTagType(JSON.parse(tagType));
    }

    // const lStatus = useSelector(state => state.linkStatus);
    // console.log(props.lStatus);
  }, []);

  useEffect(() => {
    return () => {
      if (lastTagType) {
        // console.log('Setting last tag ...')
        localStorage.setItem('last_tag_type', JSON.stringify(lastTagType));
      }
    };
  }, [lastTagType]);

  useEffect(() => {
    if (isVisible) {
      setIsOpenCamera(true);
    }
  }, [isVisible]);

  useEffect(() => {
    // console.log(linkStatus);
    if (linkStatus === 'done') {
      message.success(`Successfully linked asset!`)
      toggleView();
      setActiveTab('1');
      setNewQrId(null);
      setIsOpenCamera(false);
      setUploaded(false);
      setDocumentData([]);
      props.reset();
    }
  }, [linkStatus]);

  useEffect(() => {
    // console.log(qrUsed);
    if (qrUsed && qrUsed.id === newQrId && qrUsed.status) {
      message.error(`QR already in use!`)
      setNewQrId(null);
    }
  }, [qrUsed]);

  useEffect(() => {
    if (asset) {
      // console.log(asset)
      const scannerData = asset.scannerData || [];
      const qrData = scannerData.filter(scanner => scanner.type === linkType)
      // console.log(qrData);
      if (qrData && qrData.length)
        setQrId(qrData[0].id);
      setActiveTab('1');
      setNewQrId(null);
      setIsOpenCamera(false);
      setUploaded(false);
      setDocumentData([]);
    }
  }, [asset]);

  const toggleOpenCamera = () => {
    setIsOpenCamera(!isOpenCamera);
  };

  const handleScan = data => {
    // console.log(data);
    try {
      if (data) {
        setNewQrId(data);
      } else {
        message.error('Invalid QR!');
      }
      setLoading(false);
      setIsOpenCamera(false);
    } catch (error) {
      setLoading(false);
      setIsOpenCamera(false);
      message.error('Something went wrong!');
      console.error('Invalid QR URL:', error);
    }

  };
  const handleNext = (currentTabIndex) => {
    if (currentTabIndex + 1 <= 4) {
      setActiveTab(String(currentTabIndex + 1));
    }
  }

  const handlePrev = (currentTabIndex) => {
    if (currentTabIndex - 1 > 0) {
      setActiveTab(String(currentTabIndex - 1));
    }
  }

  const updateUploadedState = () => {
    // console.log(uploaded)
    setUploaded(true);
  };

  const getDocumentData = (data) => {
    // console.log(data);
    setDocumentData(data);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      asset: asset._id,
      tag_type: tagType && tagType._id,
      tagType_id: tagType && tagType._id,
      type: tagType && tagType.name,
      qr: newQrId,
      documents: documentData,
      latitude: coords && coords.latitude || 0,
      longitude: coords && coords.longitude || 0,
    }
    if (data.asset && data.qr) {
      // console.log(data);
      createLink(data);
    } else {
      message.error(`Invalid data to link!`)
    }
  }

  const handleTagTypeChange = (typeId) => {
    const selectedTagType = (allTagTypes || []).filter(tag => tag._id === typeId)[0]
    setTagType(selectedTagType);
    if (!lastTagType) {
      setLastTagType(selectedTagType)
    } else if (lastTagType._id !== typeId) {
      setLastTagType(selectedTagType)
    }
  }

  return (
    <div>
      <Modal
        visible={isVisible}
        onCancel={toggleView}
        destroyOnClose={true}
        footer={null}
        width={640}
      >
        <div style={{ height: '50vh' }}>
          <Tabs activeKey={activeTab} onChange={null} tabPosition={'left'} animated
            type={'line'}>
            <TabPane tab="Scan" key="1" disabled={activeTab !== '1'}>
              <div style={{ height: '400px', width: '100%' }}>
                <h4>New QR for Asset {(asset && asset.assetCode || '-') + '/' + (asset && asset.ownerCode || '-') + '/' + (asset && asset.altName || '-')}</h4>
                {newQrId && <Qrcode width={200} height={200} id={newQrId} />}
                {newQrId && <h4>QR ID : {newQrId}</h4>}

                <Button type="primary" className="gx-mb-0" htmlType={'button'}
                  onClick={toggleOpenCamera}>
                  Scan QR
                </Button>

                {
                  (isOpenCamera) ?
                    <QrScan handleScan={handleScan}
                      openCamera={isOpenCamera} toggleOpenCamera={toggleOpenCamera}
                      checkQrAlreadyUsed={checkQrAlreadyUsed} />
                    : null
                }
              </div>
              <ButtonGroup style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Button type={'primary'} onClick={() => handlePrev(1)}><Icon type="left" /> Prev</Button>
                <Button type={'primary'} disabled={!newQrId} onClick={() => handleNext(1)}>Next <Icon
                  type="right" /></Button>
              </ButtonGroup>
            </TabPane>
            <TabPane tab="Tag Type" key="2" disabled={activeTab !== '2'}>
              <div style={{ height: '400px', width: '100%' }}>
                {
                  <div style={{ marginTop: '2%', marginRight: '32%', width: '75%' }}>
                    <h4>Select Tag Type : </h4>
                    <Select
                      mode="single"
                      style={{ width: "100%" }}
                      placeholder="Please select"
                      onChange={handleTagTypeChange}
                      value={tagType && tagType._id || undefined}
                    >
                      {allTagTypes &&
                        allTagTypes.length &&
                        allTagTypes.map(item => (
                          <Select.Option key={item._id} value={item._id}>
                            {item.name}
                          </Select.Option>
                        ))}
                    </Select>
                  </div>
                }
              </div>
              <ButtonGroup style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Button type={'primary'} onClick={() => handlePrev(2)}><Icon type="left" /> Prev</Button>
                <Button type={'primary'} disabled={!tagType} onClick={() => handleNext(2)}>Next <Icon
                  type="right" /></Button>
              </ButtonGroup>
            </TabPane>
            <TabPane tab="Photo" key="3" disabled={activeTab !== '3'}>
              <div style={{ height: '400px', width: '100%' }}>
                {
                  (newQrId !== '') &&
                  <div style={{ marginTop: '2%', marginRight: '32%', width: '75%' }}>
                    <DocumentList match={match} history={history}
                      documentData={documentData}
                      form={form}
                      updateUploadedState={updateUploadedState}
                      resource={'AssetLink'}
                      getDocumentData={getDocumentData} />
                  </div>
                }
              </div>
              <ButtonGroup style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Button type={'primary'} onClick={() => handlePrev(3)}><Icon type="left" /> Prev</Button>
                <Button type={'primary'} onClick={() => handleNext(3)}>Next <Icon
                  type="right" /></Button>
              </ButtonGroup>
            </TabPane>
            <TabPane tab="Confirm" key="4" disabled={activeTab !== '4'}>
              <div style={{ height: '400px', width: '100%' }}>
                <Descriptions
                  title="Preview"
                  size={'small'}
                  column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                >
                  <Descriptions.Item label="Asset Code">{asset && asset.assetCode}</Descriptions.Item>
                  <Descriptions.Item label="Tag Type">{tagType && tagType['name']}</Descriptions.Item>
                  <Descriptions.Item label="New QR"><Qrcode width={100} height={100}
                    id={newQrId} /></Descriptions.Item>
                  <Descriptions.Item label="New QR Id">{newQrId}</Descriptions.Item>
                  <Descriptions.Item label="Photos">
                    {
                      documentData.map(file => file.name).join('<br/>')
                    }
                  </Descriptions.Item>
                </Descriptions>
              </div>
              <ButtonGroup>
                <Button type={'primary'} onClick={() => handlePrev(4)}><Icon type="left" /> Prev</Button>
                <Button type={'danger'} loading={loading || globalLoading}
                  onClick={(e) => handleSubmit(e)}>Save</Button>
              </ButtonGroup>
            </TabPane>
          </Tabs>
        </div>
      </Modal>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Linker);
